/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Array)],
  props: {
    items: {type: Array, default: () => []},
    required: {type: Boolean, default: false},
    placeholder: {type: String, default: ''},
    small: {type: Boolean, default: false}
  },
  emits: ['update:valid'],
  computed: {
    options() {
      const options = this.items.map(item => {
        if (typeof item === 'object') return item
        return {value: item, label: String(item)}
      })

      // Keep saved selections visible even if they are no longer offered.
      for (const value of this.value || []) {
        const exists = options.some(option => option.value === value)
        if (exists) continue
        options.push({value, label: String(value)})
      }

      return options
    },
    valid() {
      const value = this.value
      if (value === undefined || value === null) return !this.required
      if (!Array.isArray(value)) return false
      return !this.required || value.length > 0
    }
  }
}
